// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_Q","seoBlockContent_visible":"c-a_R"};